import { useParams } from "react-router-dom";
import cn from "classnames";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table/Table";

import TableHeader from "@/shared/components/TableHeader/TableHeader";

import style from "./style.module.css";
import useGetAssessmentInviteTestSectionLogsHook from "@/shared/hooks/tests/use-get-assessment-invite-test-section-logs.hook";
import { useMemo } from "react";
import { maybe } from "@/shared/utils/formaters/dataFormater/commonFormatter";
import { isValidNumericParam, minToSec, secondsToHms } from "@/shared/utils/common.utils";

interface IAssessmentSectionsLogs {
  testId: number;
  key: string;
  sectionName?: string;
  sectionTime: string;
  usedTime: string;
}

const columns: ColumnsType<IAssessmentSectionsLogs> = [
  {
    key: "sectionName",
    title: "Section",
    dataIndex: "sectionName",
    className: style.tableColumn,
  },
  {
    key: "sectionTime",
    title: "Time Limit",
    dataIndex: "sectionTime",
    className: style.tableColumn,
    render: (value) => (value !== "No Limit" ? `${value} m` : value),
  },
  {
    key: "usedTime",
    title: "Used Time",
    dataIndex: "usedTime",
    className: style.tableColumn,
    render: (value, record) => {
      return (
        <span className={cn({ [style.dangerousColor]: value === record.sectionTime })}>
          {value !== "N/A" ? `${value} m` : value}
        </span>
      );
    },
  },
];

export default function TableAuditTestSectionLogs() {
  const { invite_id: inviteIdFromParams } = useParams();
  const { testSectionLogs, isLoading } = useGetAssessmentInviteTestSectionLogsHook(Number(inviteIdFromParams));

  const testSectionTimeLogs = useMemo(() => {
    return testSectionLogs
      .map((test) =>
        test.sections.map((section) => {
          const timeInSec = maybe(section.timeLimit, minToSec, "No Limit");
          return {
            testId: test.testId,
            key: `${test.testId}-${section.name}`,
            testName: test.testName,
            sectionName: `${test.testName} - ${section.name}`,
            sectionTime: isValidNumericParam(Number(timeInSec)) ? secondsToHms(Number(timeInSec)) : timeInSec,
            usedTime: maybe(section.timeSpent, secondsToHms),
          };
        }),
      )
      .flat();
  }, [testSectionLogs]);

  return (
    <>
      {Boolean(testSectionTimeLogs.length) && (
        <div className={cn(style.auditTable, style.lastTable)}>
          <TableHeader tableName="Test Section Logs" hasSearchField={false} />
          <Table
            columns={columns}
            dataSource={testSectionTimeLogs}
            loading={isLoading}
            style={{ width: "100%" }}
            pagination={{
              position: ["bottomLeft"],
              showSizeChanger: true,
            }}
          />
        </div>
      )}
    </>
  );
}
